type PlaceholderValues = {
  desktop: { width: number | string; height: number | string } | null;
  mobile: { width: number | string; height: number | string } | null;
};

type FeedInjectable = {
  placement: string;
  placeholderValues: PlaceholderValues;
};

const xandrPlacementInFeedSearchMap: Map<string, FeedInjectable> = new Map([
  [
    "feedPanorama",
    {
      placement: "feed.feedPanorama", // search path in in placementMap
      placeholderValues: { desktop: { width: 980, height: 240 }, mobile: null },
    },
  ],
  [
    "fullscreen",
    {
      placement: "feed.fullscreen", // search path in in placementMap
      placeholderValues: {
        desktop: null,
        mobile: { width: "100vw", height: "100vh" },
      },
    },
  ],
  [
    "contentDisplay",
    {
      placement: "feed.contentDisplay", // search path in in placementMap
      placeholderValues: {
        desktop: { width: "100%", height: 240 },
        mobile: { width: "100%", height: 240 },
      },
    },
  ],
]);

const xandrNativePlacementInFeedSearchMap: Map<string, FeedInjectable> =
  new Map([
    [
      "backFillMobile",
      {
        placement: "feed.backFillMobile", // search path in in placementMap
        placeholderValues: {
          desktop: { width: "100%", height: 240 },
          mobile: null,
        },
      },
    ],
    [
      "backFillDesktop",
      {
        placement: "feed.backFillDesktop", // search path in in placementMap
        placeholderValues: {
          desktop: { width: "100%", height: 240 },
          mobile: null,
        },
      },
    ],
    [
      "injectableDesktop",
      {
        placement: "feed.injectableDesktop", // search path in in placementMap
        placeholderValues: {
          desktop: { width: "100%", height: 240 },
          mobile: null,
        },
      },
    ],
    [
      "injectableMobile",
      {
        placement: "feed.injectableMobile", // search path in in placementMap
        placeholderValues: {
          desktop: null,
          mobile: { width: "100vw", height: 240 },
        },
      },
    ],
  ]);

export { xandrPlacementInFeedSearchMap, xandrNativePlacementInFeedSearchMap };
